export default "__VITE_ASSET__B$wLRRhV__"